export interface Staff {
  id: Id;
  serial: Serial;
  kind: StaffKind;
  phone: Phone;
  name: Name;
}

export const staffEmpty: Staff = {
  id: -1,
  serial: '',
  kind: 'Doctor',
  phone: '',
  name: '',
};

export interface StaffDto {
  id: Id;
  serial: Serial;
  category: Category;
  phone: Phone;
  name: Name;
}

export const staffFromDto = (staffDto: StaffDto): Staff => {
  return {
    ...staffDto,
    kind: staffKindFromDto(staffDto.category),
  };
};

export const staffDtoFromStaff = (staff: Staff): StaffDto => {
  return {
    ...staff,
    category: staffKindToDto(staff.kind),
  };
};

export const staffKindToDto = (staffKind: StaffKind | 'All'): string => {
  if (staffKind === 'All') {
    return '';
  } else if (staffKind === 'Doctor') {
    return 'MANAGER_DOCTOR';
  } else if (staffKind === 'Nurse') {
    return 'MANAGER_NURSE';
  } else if (staffKind === 'Nonmedical Personnel') {
    return 'MANAGER_NONE';
  } else {
    // eslint-disable-next-line no-throw-literal
    throw 'invalid';
  }
};

export const staffKindFromDto = (category: Category): StaffKind => {
  if (category === 'MANAGER_DOCTOR') {
    return 'Doctor';
  } else if (category === 'MANAGER_NURSE') {
    return 'Nurse';
  } else if (category === 'MANAGER_NONE') {
    return 'Nonmedical Personnel';
  } else {
    /// invalid
    return 'Doctor';
  }
};
